import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import ColorOption from "../ColorOption";
import {useAppData} from "../../context/Contexts";
import React, {useEffect, useState} from "react";
import {formatMoney, getCurrency, getNewPartNumber, getOfferPrice, parseSeatValue} from "../../helpers/helpers";


export default function Step3(props) {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [opts, setOpts] = useState([]);
    const [price, setPrice] = useState('');

    const [comparePrice, setComparePrice] = useState('');
    const [comparePrice1, setComparePrice1] = useState('');
    const [savings, setSavings] = useState<undefined | string>(undefined);
    const [savings1, setSavings1] = useState<undefined | string>(undefined);

    let seat = '';

    // console.log('currentAppData.selectedId', currentAppData.selectedId);

    useEffect(() => {
        let product = currentAppData.originalProduct;
        if (currentAppData.check && currentAppData.check.compatibility_custom !== 'N') {
            product = currentAppData.product;
        }

        // console.log('product', product);
        const filtered = product && product.variants && product.variants.edges.length > 0 ?
            product.variants.edges.filter(el => el.node.id.replace('gid://shopify/ProductVariant/', '') === '' + currentAppData.selectedId) : [];
        // console.log('filtered', filtered);
        if (filtered.length > 0) {
            const currency = getCurrency(filtered[0].node.priceV2.currencyCode);
            setPrice(currency + '' + filtered[0].node.priceV2.amount);

            if (filtered[0].node.compareAtPrice) {
                setComparePrice(currency + '' + filtered[0].node.compareAtPrice.amount);
                setComparePrice1(filtered[0].node.compareAtPrice.amount);
                setSavings1(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount));
                setSavings(currency + '' + formatMoney(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount)));
            } else {
                if (window.scs_show_earlybf_section) {
                    setSavings(currency + '' + formatMoney(20));
                } else {
                    setSavings(undefined);
                }
            }
        } else {
            setSavings(undefined);
        }




    }, [currentAppData.selectedId]);

    useEffect(() => {

        let product = currentAppData.originalProduct;
        if (currentAppData.check && (currentAppData.check.compatibility === 'N' || currentAppData.check.compatibility === 'A')) {
            product = currentAppData.product;
        } else {
            product = currentAppData.originalProduct;
        }
        // console.log('product', product);
        // console.log('currentAppData step3', currentAppData);


        seat = parseSeatValue(currentAppData.seat, currentAppData?.check?.compatibility_custom);

        const check = currentAppData.check;
        // console.log('seat step3', seat);
        if (!seat || seat === '') {
            // setCurrentAppData(prevState => {
            //     return {...prevState, step: 2}
            // })
            return;
        }

        const availableColors1 = product.variants.edges
            //.filter(v => v.node.availableForSale === true)
            .filter(v => v.node.selectedOptions
                .filter(el => el.name === 'Seats' && el.value === seat).length > 0);

        //console.log('availableColors', availableColors1);

        //console.log('currentAppData', currentAppData);

        const availableColors = (check && check.compatibility !== 'N' && check.compatibility !== 'A') ? availableColors1.filter(v => {
            const color = v.node.selectedOptions.filter(ep => ep.name === 'Color')[0].value;
            if (check) {
                return check.availability && check.availability[seat] && typeof check.availability[seat][color] !== 'undefined' && check.availability[seat][color] === true;
            }
            return true;
        }) : availableColors1;

        //DONE: filter availableColors by Sku to check data from parts inventory

        setOpts(availableColors);

        if (availableColors.length > 0) {
            const val = availableColors[0].node.selectedOptions.filter(ep => ep.name === 'Color')[0].value;
            const id = availableColors[0].node.id.replace('gid://shopify/ProductVariant/', '');

            setCurrentAppData(previousState => {
                return {...previousState, color: val, selectedId: id};
            });
        }

    }, [currentAppData.check, currentAppData.product, currentAppData.originalProduct,
        currentAppData.seat, currentAppData.year, currentAppData.make, currentAppData.model]);

    const handleChange = (e) => {
        let id = e.target.dataset.id.replace('gid://shopify/ProductVariant/', '');
        // console.log('selected id', id);
        const parsed_seat = parseSeatValue(currentAppData.seat, currentAppData?.check?.compatibility_custom);
        if (parsed_seat !== currentAppData.seat) {
            // find variant id for this specific parsed_seat
            // console.log('seat and color: ', parsed_seat, e.target.value);
            const seats_filtered = currentAppData.product.variants.edges.filter(v =>
                v.node.selectedOptions.filter(ep => ep.name === 'Seats' && ep.value === parsed_seat).length > 0);

            // console.log('seats_filtered: ', seats_filtered);
            const filtered_by_color = seats_filtered
                .filter(v => v.node.selectedOptions.filter(ep => ep.name === 'Color' && ep.value === e.target.value).length > 0);

            // console.log('filtered_by_color: ', filtered_by_color);
            if (filtered_by_color.length > 0)
                id = filtered_by_color[0].node?.id?.replace('gid://shopify/ProductVariant/', '');
            // console.log('selected id filtered: ' + id);
        }

        setCurrentAppData(prevState => {
            return {...prevState, color: e.target.value, selectedId: id}
        })
    }

    const data = document.querySelector('#payment_terms').innerHTML;
    // console.log('data: ', data);
    //DONE: fix savings

    function getSkuFromId(selectedId) {
        const filtered = currentAppData?.product?.variants?.edges.filter(v => v.node.id.replace('gid://shopify/ProductVariant/', '') == selectedId);
        if (filtered.length == 0) {
            return '';
        }
        return filtered[0].node?.sku;
    }

    const hasAlert = function (currentAppData) {
        if (window.scs_bulk_alert_colors) {
            let hasAlert = false;
            window.scs_bulk_alert_colors.forEach((color) => {
                const colorParts = color.split(';');
                console.log(colorParts);
                const sku = colorParts[0];
                const alert = colorParts[1];
                console.log('sku:', getSkuFromId(currentAppData.selectedId));
                if (getSkuFromId(currentAppData.selectedId) === sku) {
                    hasAlert = true;
                }
            })
            console.log('hasAlert:', hasAlert);
            if (hasAlert) {
                return true;
            }
        }

        return window.scs_show_color_alert && window.scs_alert_colors && window.scs_alert_colors.includes(currentAppData.color) &&
            ['Universal Back Bench', 'Bundle'].includes(currentAppData.seat);
    }

    const getAlert = function (currentAppData) {
        if (window.scs_bulk_alert_colors) {
            let hasAlert = '';
            window.scs_bulk_alert_colors.forEach((color) => {
                const colorParts = color.split(';');
                const sku = colorParts[0];
                const alert = colorParts[1];
                if (getSkuFromId(currentAppData.selectedId) === sku) {
                    hasAlert = alert;
                }
            })
            if (hasAlert != '') {
                return hasAlert.replace('[item]', currentAppData.color);
            }
        }

        return window.scs_product_alert_text?.replace('[item]', currentAppData.color);
    }

    return (<>
        {currentAppData.step > 2 ?
            <section
                className={`step_3 ${styles.section__step} ${currentAppData?.step == 3 ? styles.section_active : ''}`}
                id={`${styles.step_3}`}>
                <h2>Step 3/3 - <strong>Color Details</strong></h2>
                <div className={`${localStyles.color_selector}`}>
                    {opts && opts.map(el => {
                        const val = el.node.selectedOptions.filter(ep => ep.name === 'Color')[0].value;

                        //console.log(currentAppData.color, '==', val, currentAppData.color === val);

                        return (<ColorOption key={`${props.id}-${el.node.id}`}
                                             masterId={props.id}
                                             value={val}
                                             id={`${el.node.id}`} name="Color" onChange={handleChange}
                                             checked={currentAppData.color === val}/>);
                    })}
                </div>

                <div className={`${styles.summary}`}>

                </div>

                {savings && !window.scs_show_color_alert && !window.scs_black_friday_2025 ? (
                    <div className={`${styles.savings}`}>
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_953_3054)">
                                <path
                                    d="M13.7499 0.110046H8.55454C8.21086 0.110046 7.7305 0.309154 7.48767 0.551803L0.364771 7.67466C-0.12159 8.16048 -0.12159 8.95698 0.364771 9.4422L5.66835 14.7456C6.15361 15.2314 6.94934 15.2314 7.43534 14.745L14.5582 7.62328C14.8008 7.38067 15 6.89955 15 6.55659V1.3601C15 0.672725 14.4373 0.110046 13.7499 0.110046ZM11.2498 5.11007C10.5594 5.11007 9.99975 4.54981 9.99975 3.86002C9.99975 3.16909 10.5594 2.60997 11.2498 2.60997C11.9402 2.60997 12.5 3.16909 12.5 3.86002C12.5001 4.54981 11.9402 5.11007 11.2498 5.11007Z"
                                    fill="black"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_953_3054">
                                    <rect width="15" height="15" fill="white" transform="translate(0 0.109924)"/>
                                </clipPath>
                            </defs>
                        </svg>
                        You Saved: <span
                        className={`${styles.savings_price}`}>{savings}</span> ({(savings1 / comparePrice1 * 100).toFixed(0)}%)
                    </div>
                ) : ''}
                {hasAlert(currentAppData) ? (<div className={`${styles.stock_alert}`}>
                    <div className={`${styles.text}`}>{getAlert(currentAppData)}</div>
                </div>) : ''}

                {window.scs_step_1_bottom_text ? <div className={`${styles.bottom_text}`}
                                                      dangerouslySetInnerHTML={{__html: `${window.scs_step_1_bottom_text}`}}></div> : ''}

                <div className={`${localStyles.payment_terms}`} dangerouslySetInnerHTML={{__html: data}}></div>


            </section> : ''}
    </>);
}
